<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-02-18 14:21:56
 * @LastEditTime : 2020-02-18 14:35:15
 -->
<template>
  <section>
    <div
      v-for="(val,key) in ids"
      :key="key"
      class="wrapper"
    >
      <div class="left">
        <svg>
          <use :xlink:href="val" />
        </svg>
      </div>
      <div class="right">
        <code>{{ val }}</code>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      ids: [
        '#zoomOut', '#invalid', '#zoomIn', '#previousOne', '#disPreviousOne', '#nextOne', '#disNextOne',
        '#iconFullScreen', '#iconFullRecovery', '#expendRightcolumn', '#disExpendRightcolumn',
        '#retractRightcolumn', '#rightRotation', '#leftRotation', '#previousPage',
        '#nextPage', '#expendLeftcolumn', '#retractLeftcolumn', '#open',
        '#close', '#sure', '#success', '#message', '#error', '#more', '#badfile',
        '#noPower', '#delete', '#edit', '#copy', '#word', '#three_d', '#ae', '#ai',
        '#apk', '#au', '#cad', '#cpp', '#dps', '#ps', '#rp', '#setting', '#sketch',
        '#svg', '#text', '#video', '#visio', '#wps', '#zip', '#mpp', '#music',
        '#numbers', '#sort-entry', '#other', '#pages', '#pdf', '#pic', '#ppt', '#prproj', '#dw',
        '#et', '#excel', '#exe', '#fl', '#id', '#iso', '#key', '#leboxnote',
        '#lock', '#max', '#folder-share-private', '#folder-team', '#folder-share',
        '#folder', '#html', '#iconStar', '#iconStarl', '#iconLock', '#loadFail',
        '#backQuotation', '#frontQuotation', '#musicwh', '#list-view', '#card-view',
        '#gou', '#folder-share-hybrid', '#folder-team-hybrid', '#folder-team-private', '#tiyan', '#logo',
        '#download', '#save', '#preview', '#arr-down', '#arr-up', '#loupe', '#warn', '#filelist-empty', '#dian',
        '#ent', '#self', '#share_in', '#share_out', '#w-close', '#b-close',
      ],
    }
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
section{
  overflow: auto;
  height: 100%;
}
.wrapper{
  display: flex;
  align-items: center;     /* 垂直居中 */
  width: 377px;
  height: 130px;
  border: 1px solid red;
  float: left;
}
.left{
  display: inline-block;
  margin-right: 20px;
  svg{
    width: 100%;
    height: 100%;
    max-width: 300px;
    max-height: 120px;
    // width:100px;
    // height: 100px;
  }
}
.right{
  display: inline-block;
  user-select: all;
  font-size: 20px;
  margin-right: 10px;
}
</style>
